import { Text, VStack, Flex, Grid, Box } from '@chakra-ui/react'
import Image from 'next/image'
import { useTranslation } from 'next-i18next'

import { NAVIGATION_BAR_HEIGHT } from '@/components/NavigationBar/constants'

import MobileBgImage from '@/images/resources/bg-mobile.jpg'
import DesktopBgImage from '@/images/resources/bg-desktop.jpg'

function Hero(): React.ReactElement {
  const { t } = useTranslation('resource')

  return (
    <Flex
      as="section"
      id="hero"
      sx={{
        w: 'full',
        minH: {
          base: `calc(100vh - ${NAVIGATION_BAR_HEIGHT.base})`,
          md: `calc(100vh - ${NAVIGATION_BAR_HEIGHT.md})`,
        },
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        mixBlendMode: 'multiply',
      }}
    >
      <Box
        layerStyle="fullPageBackgroundImage"
        sx={{
          display: { base: 'block', md: 'none' },
        }}
      >
        <Image
          priority
          src={MobileBgImage}
          alt=""
          placeholder="blur"
          objectFit="cover"
          layout="fill"
        />
      </Box>
      <Box
        layerStyle="fullPageBackgroundImage"
        sx={{
          display: { base: 'none', md: 'block' },
        }}
      >
        <Image
          priority
          src={DesktopBgImage}
          alt=""
          placeholder="blur"
          objectFit="cover"
          layout="fill"
        />
      </Box>
      <Grid
        layerStyle="container"
        sx={{
          gridTemplateColumns: {
            base: '1fr',
            md: 'repeat(2, 1fr)',
          },
          gridGap: {
            base: 6,
            md: 0,
          },
          alignItems: 'center',
        }}
      >
        <VStack
          spacing="4"
          sx={{
            fontWeight: 'medium',
            alignItems: {
              base: 'center',
              md: 'flex-start',
            },
            color: 'white',
            textAlign: {
              base: 'center',
              md: 'left',
            },
            gridColumn: {
              base: '1',
              md: '2',
            },
          }}
        >
          <Text
            as="h1"
            sx={{
              color: 'white',
              fontWeight: 'bold',
              fontSize: {
                base: '3xl',
                sm: '5xl',
                md: '5.5xl',
              },
              lineHeight: {
                base: '50px',
                sm: '68px',
                md: '72px',
              },
            }}
          >
            {t('list.hero.title')}
          </Text>
          <Text
            as="h2"
            sx={{
              color: 'white',
              fontSize: {
                base: 'xl',
                sm: '3.5xl',
              },
            }}
          >
            {t('list.hero.subtitle')}
          </Text>
        </VStack>
      </Grid>
    </Flex>
  )
}

export default Hero
